/* eslint-disable max-lines */
import { render as reactRender } from 'react-dom';
import { Suspense } from 'react';
import { formatLanguageLocale } from 'common/utils/locale';
import { QueryClient, QueryClientProvider } from 'react-query';
import { HotmartRum } from '@hot-observability-js/react';
import Chat from 'pages/chat';
import { getUserData } from 'common/user';

export default async function render(
  rootElement: HTMLElement | null,
  props: {
    baseUrl?: string;
    userId: number;
    email?: string;
    name?: string;
    entityType?: string;
    language: string;
    guestAccess: boolean;
    isEnabled?: boolean;
    attendantId?: number;
    attendantEmail?: string;
  }
): Promise<void> {
  const { baseUrl, guestAccess, isEnabled, language } = props;
  // eslint-disable-next-line no-undef,@typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = `${baseUrl || ''}/`;

  if (rootElement) {
    rootElement.classList.add('app-blip-chat');

    const { locale: userLocale, id: userId, email, name, entityType, attendantId, attendantEmail } = getUserData();

    const locale = formatLanguageLocale(language || userLocale);
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
        },
      },
    });
    const initial = (
      <HotmartRum.ErrorBoundary
        fallback={<></>}
        beforeCapture={(scope, error) => {
          const message = `${error?.name || 'Generic Error'} - ${error?.message}`;
          if (userId) {
            scope.setUser({
              id: userId.toString(),
              locale,
              email,
              name,
              entityType,
            });
          }
          scope.setExtras({ stack: error?.stack, message });
        }}
      >
        <Suspense fallback={null}>
          <QueryClientProvider client={queryClient}>
            <Chat
              locale={locale}
              userId={userId}
              email={email}
              name={name}
              entityType={entityType}
              guestAccess={guestAccess}
              isEnabled={isEnabled}
              attendantId={attendantId}
              attendantEmail={attendantEmail}
            />
          </QueryClientProvider>
        </Suspense>
      </HotmartRum.ErrorBoundary>
    );
    reactRender(initial, document.getElementById('app-blip-chat'));
  } else {
    console.error('rootElement not found. Please verify if div ID matches');
  }
}
if (process.env.NODE_ENV === 'development') {
  import('../auth-cas').then(module => {
    const { bootstrap } = module;
    bootstrap.start();
  });
  const root = document.getElementById('app-blip-chat');

  render(root, {
    userId: 11686828,
    email: 'marcelo.lima@hotmart.com',
    name: 'Marcelo Medeiros de Lima',
    language: 'pt_BR',
    guestAccess: false,
    entityType: 'LEGAL_ENTITY',
    isEnabled: true,
  });
}
